import React, { useRef, useState } from 'react';
import { Menu } from '@mui/material';

import CaretDown from '../../../Icons/icons/CaretDown';

import '../styles/usernameDropdown.scss';

import ShortString from '../../../common-components/ShortString/ShortString';

const UserNameDropDown = ({ options = [], onSelect, selected }) => {
  const [dropDownAnc, setDropDownAnc] = useState(null);
  const dropDownRef = useRef();

  return (
    <>
      <div
        ref={dropDownRef}
        className="user-name-dropdown"
        onClick={(e) => {
          if (options.length !== 1) {
            setDropDownAnc(dropDownRef.current);
          }
        }}>
        <span className="uppercase center">
          {selected?.firstName?.charAt(0)}
          {selected?.lastName?.charAt(0)}
        </span>
        <p className="capitalize flex-between center flex-1">
          <ShortString
            stringLength={options.length > 1 ? 9 : 10}
            name={`${selected?.firstName} ${selected?.lastName}`}
          />
          {options.length > 1 && <CaretDown style={{ transform: dropDownAnc ? 'rotate(180deg)' : '' }} />}
        </p>
      </div>
      <Menu open={Boolean(dropDownAnc)} anchorEl={dropDownAnc} onClose={() => setDropDownAnc(null)}>
        <div style={{ width: dropDownRef.current?.clientWidth }} className="user-name-dropdown-container ">
          {options.map((option) => (
            <UserNameOption
              key={option?._id}
              option={option}
              onClick={() => {
                onSelect(option._id);
                setDropDownAnc(null);
              }}
            />
          ))}
        </div>
      </Menu>
    </>
  );
};

export const UserNameOption = ({ option, ...rest }) => {
  return (
    <div {...rest} className="user-name-dropdown-option">
      <span className="uppercase">
        {option?.firstName?.charAt(0)}
        {option?.lastName?.charAt(0)}
      </span>
      <p className="capitalize">
        <ShortString stringLength={12} name={`${option?.firstName} ${option?.lastName}`} />
      </p>
    </div>
  );
};

export const UserNameShow = ({ name, ...rest }) => {
  const firstName = name?.split(' ')[0] || '';
  const lastName = name?.split(' ')[1] || '';
  return (
    <div className="user-container center">
      <div {...rest} className="inner-container center">
        <span className="initials center">
          {firstName?.charAt(0)}
          {lastName?.charAt(0)}
        </span>
        <p className="name">
          <ShortString stringLength={11} name={`${firstName} ${lastName}`} />
        </p>
      </div>
    </div>
  );
};

export default React.memo(UserNameDropDown);
